function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from "react";
import _ from "lodash";
import { commonSelectOptions } from "../utils";
import Switch from "react-switch";
import { ColorPicker } from "../components";
import { LoadableBasicWYSIWYG } from "./LoadableBasicWYSIWYG";
import "../styles-common.scss";
import "../styles-editor.scss";
import "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
/**
 * A base compment to use with interaction editors, this component implements
 * several common methods that can be used accross most interaction editors..
 *
 * @class BaseInteractionEditor
 * @extends {Component}
 */

var BaseInteractionEditor = /*#__PURE__*/function (_Component) {
  _inherits(BaseInteractionEditor, _Component);

  var _super = _createSuper(BaseInteractionEditor);

  function BaseInteractionEditor(props) {
    var _this;

    _classCallCheck(this, BaseInteractionEditor);

    _this = _super.call(this, props);
    var config = props.config;

    if (!config.meta) {
      config.meta = {};
    }

    if (!config.preview) {
      config.preview = {};
    }

    if (config.items) {
      _.each(config.items, function (item, idx) {
        item.uid = _.uniqueId();
      });
    }

    _this.state = {
      config: config,
      currentRevision: 0,
      revisions: []
    };
    _this.handleChangeEvent = _this.handleChangeEvent.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleSwitchChange = _this.handleSwitchChange.bind(_assertThisInitialized(_this));
    _this.addItem = _this.addItem.bind(_assertThisInitialized(_this));
    _this.removeItem = _this.removeItem.bind(_assertThisInitialized(_this));
    _this.goBackOneRevision = _this.goBackOneRevision.bind(_assertThisInitialized(_this));
    _this.setRevision = _this.setRevision.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Add a new item to this interactions configuration. This will try and clone
   * an existing item to use as a starting point, if it cannot find an item to
   * use it will pull from the defaultItem() method, which each editor should
   * implement.
   *
   * @memberof BaseInteractionEditor
   */


  _createClass(BaseInteractionEditor, [{
    key: "addItem",
    value: function addItem() {
      var items = this.state.config.items;

      if (items.length == 0) {
        var item = this.defaultItem();
      } else {
        // Clone an existing item as a starting point
        var item = _.cloneDeep(this.state.config.items[0]);
      }

      this.state.config.items.push(item);
      this.setState({
        config: this.state.config
      });
    }
    /**
     * Clone an existing item and add it to the item list.
     *
     * @param {*} item
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "cloneItem",
    value: function cloneItem(item) {
      var newItem = _.cloneDeep(item);

      this.state.config.items.push(newItem);
      this.setState({
        config: this.state.config
      });
    }
    /**
     * Copy the style attributes from 1 item to all other items.
     *
     * @param {*} item
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "copyStyles",
    value: function copyStyles(item) {
      var newStyles = item.attributes;

      _.each(this.state.config.items, function (item) {
        item.attributes = _.cloneDeep(newStyles);
      });

      this.setState({
        config: _objectSpread({}, this.state.config)
      });
    }
    /**
     * Reorder the items.
     *
     * @param {*} order
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "reorderItems",
    value: function reorderItems(order) {
      var _this2 = this;

      var ordered = [];

      _.each(order, function (i) {
        ordered.push(_this2.state.config.items[i]);
      });

      this.state.config.items = ordered;
      this.setState({
        config: this.state.config
      });
    }
    /**
     * Remove an item from the interaction.
     *
     * @param {*} idx - Index of the item in the config.items array.
     * @param {*} event
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "removeItem",
    value: function removeItem(idx, event) {
      event.stopPropagation();
      this.state.config.items.splice(idx, 1);
      this.setState({
        config: this.state.config
      });
    }
    /**
     * Add a revision to the state. This method accepts a field and a value, the
     * field can be a path to a deeper location in the configuration, for example
     * items[0].drag.name or design.width.
     *
     * @param {*} field - Field that as revised.
     * @param {*} value - New value.
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "setRevision",
    value: function setRevision(field, value) {
      var revisions = this.state.revisions;
      revisions.push({
        field: field,
        value: value
      });
      this.setState({
        revisions: revisions,
        currentRevision: this.state.currentRevision + 1
      });
    }
    /**
     * Go back a single revision.
     *
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "goBackOneRevision",
    value: function goBackOneRevision() {
      var revisions = _objectSpread({}, this.state.revisions);

      var revision = this.state.revisions[this.state.currentRevision - 1];

      var config = _objectSpread({}, this.state.config);

      _.set(config, revision.field, revision.value);

      if (this.state.currentRevision - 1 == 0) {
        revisions = [];
      } else {
        delete revisions[this.state.currentRevision - 1];
      }

      this.setState({
        config: config,
        currentRevision: this.state.currentRevision - 1,
        revisions: revisions
      });
    }
    /**
     * Update the config with a new value for a field.
     *
     * @param {*} field - Field name, this can be a path.
     * @param {*} value - new value.
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "handleChange",
    value: function handleChange(field, value) {
      _.set(this.state.config, field, value);

      this.setState({
        config: this.state.config
      });
    }
    /**
     * Event handler for form inputs.
     *
     * @param {*} e
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "handleChangeEvent",
    value: function handleChangeEvent(e) {
      var target = e.target;
      var value = target.type === "checkbox" ? target.checked : target.value;
      this.handleChange(e.target.name, value);
    }
    /**
     * Event handler for react-switches
     *
     * @param {*} checked
     * @param {*} event
     * @param {*} id
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "handleSwitchChange",
    value: function handleSwitchChange(checked, event, id) {
      this.handleChange(id, checked);
    }
    /**
     * @param {*} name - input name.
     * @param {*} value - inital content.
     * @returns
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "makeWYSIWYG",
    value: function makeWYSIWYG(name, value) {
      return /*#__PURE__*/React.createElement(LoadableBasicWYSIWYG, {
        changeHandler: this.handleChange,
        name: name,
        editorId: "e_" + _.uniqueId(),
        media: this.props.media,
        value: value
      });
    }
    /**
     * Make a switch input using common settings.
     *
     * @param {*} label - Text for the <label> element.
     * @param {*} name - Input name.
     * @param {*} checked - Default switch state.
     * @returns
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "makeSwitch",
    value: function makeSwitch(label, name, checked) {
      return /*#__PURE__*/React.createElement("label", {
        htmlFor: name,
        style: {
          display: "block"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6"
      }, /*#__PURE__*/React.createElement("span", null, label)), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-6 text-center"
      }, /*#__PURE__*/React.createElement(Switch, {
        onChange: this.handleSwitchChange,
        name: name,
        checked: checked === undefined ? false : checked,
        id: name,
        onColor: "#86d3ff",
        onHandleColor: "#2693e6",
        handleDiameter: 30,
        uncheckedIcon: false,
        checkedIcon: false,
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.6)",
        activeBoxShadow: "0px 0px 1px 10px rgba(0, 0, 0, 0.2)",
        height: 20,
        width: 48
      }))));
    }
    /**
     * Generate common fields commonly used on the settings tab in the editor.
     *
     * @returns
     * @memberof BaseInteractionEditor
     */

  }, {
    key: "makeMetadataFields",
    value: function makeMetadataFields() {
      var _React$createElement;

      var config = this.state.config;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "igloo-input-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "interaction-name"
      }, "Name:"), /*#__PURE__*/React.createElement("input", {
        className: "browser-default igloo-input",
        name: "meta.name",
        onChange: this.handleChangeEvent,
        id: "interaction-name",
        type: "text",
        value: config.meta.name
      })), /*#__PURE__*/React.createElement("div", {
        className: "igloo-input-group"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "interaction-description"
      }, "Description:"), /*#__PURE__*/React.createElement("textarea", (_React$createElement = {
        className: "browser-default igloo-input",
        id: "interaction-description",
        name: "description"
      }, _defineProperty(_React$createElement, "name", "meta.description"), _defineProperty(_React$createElement, "defaultValue", config.meta.description), _defineProperty(_React$createElement, "onChange", this.handleChangeEvent), _React$createElement))), /*#__PURE__*/React.createElement(ColorPicker, {
        changeHandler: this.handleChange,
        label: "Preview background color:",
        value: config.preview.background_color,
        name: "preview.background_color"
      }), /*#__PURE__*/React.createElement("div", {
        className: "igloo-input-group"
      }, /*#__PURE__*/React.createElement("label", null, "Icon"), /*#__PURE__*/React.createElement("select", {
        className: "browser-default igloo-input",
        onChange: this.handleChangeEvent,
        defaultValue: config.meta.icon,
        name: "meta.icon"
      }, commonSelectOptions(this.props.media))), /*#__PURE__*/React.createElement("div", {
        className: "igloo-input-group switch"
      }, this.makeSwitch("Make public?", "meta.is_public", config.meta.is_public), /*#__PURE__*/React.createElement("p", {
        className: "help-block"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-info-circle"
      }), " Making this interaction public will add it to the", " ", /*#__PURE__*/React.createElement("strong", null, "Public Interactions"), " list. Other users will be able to use this interaction or clone it into their own account.")), /*#__PURE__*/React.createElement("div", {
        className: "igloo-input-group switch"
      }, this.makeSwitch("Disable SCORM reporting?", "meta.disable_scorm", config.meta.disable_scorm)));
    }
  }]);

  return BaseInteractionEditor;
}(Component);

export default BaseInteractionEditor;